const ChipElement = require("../elements/chip.js");
const ButtonIcon = require("../elements/buttonicon.js");
const Button = require("../elements/button.js");
const html = require("choo/html");
const InputText = require("../elements/inputtext.js");
module.exports = function GameControls(state, emit) {
  let chipButtons = [];
  let disabledByTutorialButtons = [];
  let resetButtonHighlighted = false;
  let rewindButtonHighlighted = false;
  let stepForwardButtonHighlighted = false;
  let playPauseButtonHighlighted = false;
  if (state.playingTutorial) {
    const tutorialStep = state.currentTutorial[state.currentTutorialStep];
    disabledByTutorialButtons = tutorialStep.disabledButtons || [];
    if (tutorialStep.highlights && tutorialStep.highlights.gameControls) {
      resetButtonHighlighted =
        tutorialStep.highlights.gameControls.includes("reset-level-button");
      rewindButtonHighlighted =
        tutorialStep.highlights.gameControls.includes("rewind-button");
      stepForwardButtonHighlighted =
        tutorialStep.highlights.gameControls.includes("step-forward-button");
      playPauseButtonHighlighted =
        tutorialStep.highlights.gameControls.includes("play-pause-button");
    }
  }

  if (state.playingTutorial && !app.state.currentTutorial.showGameControls) {
    chipButtons = [
      ButtonIcon({
        id: "reset-level-button",
        icon: "refresh",
        disabled:
          state.getHistory().length === 0 ||
          disabledByTutorialButtons.includes("reset-level-button"),
        onClick: () => emit("reset-level"),
        highlighted: resetButtonHighlighted,
      }),
    ];
  } else {
    chipButtons = [
      ButtonIcon({
        icon: "undo",
        disabled:
          state.getHistory().length === 0 ||
          state.isMenuOpen ||
          disabledByTutorialButtons.includes("rewind-button"),
        onClick: () => emit("rewind"),
        id: "rewind-button",
        highlighted: rewindButtonHighlighted,
      }),
      ButtonIcon({
        icon: state.isGamePlaying ? "pause" : "play",
        id: "play-pause-button",
        onClick: () => emit("toggle-play"),
        disabled:
          state.isMenuOpen ||
          disabledByTutorialButtons.includes("play-pause-button"),
        highlighted: playPauseButtonHighlighted,
      }),
      ButtonIcon({
        icon: "redo",
        disabled:
          state.future.length === 0 ||
          state.isMenuOpen ||
          disabledByTutorialButtons.includes("step-forward-button"),
        onClick: () => emit("step-forward"),
        id: "step-forward-button",
        highlighted: stepForwardButtonHighlighted,
      }),
    ];
  }
  const chip = ChipElement({
    children: chipButtons,
  });

  const renameProjectButton = ButtonIcon({
    id: "rename-project-button",
    icon: "pencil",
    onClick: () => emit("start-renaming-project", state.projectMetadata.id),
    selected: state.isRenamingProject,
  });
  // GameControls.js  (inside levelsChip children array)

  const titleNode = state.isRenamingProject
    ? InputText({
        // wrapper div
        id: "rename-project-wrapper",
        // actual <input> element
        inputId: "rename-project-input",
        value: state.projectMetadata.title,
        placeholder: "Project name",
        label: "", // no visible label inside the chip
        autoFocus: true,

        // Events
        onKeyDown: (e) => {
          if (e.key === "Enter") emit("rename-project", e.target.value.slice(0, 36).trim());
          if (e.key === "Escape") emit("stop-renaming-project");
        },
        onBlur: (e) => emit("rename-project", e.target.value.slice(0, 36).trim()),
        // optional: keep the click from bubbling to the chip
        onClick: (e) => e.stopPropagation(),

        // make the field visually fit the chip
        extraStyle: "width: 140px; margin: 0; padding: 0;",
      })
    : Button({
        id: "level-select-chip",
        text: state.projectMetadata.title,
        selected: state.showLevelsPanel,
        onClick: () => emit("toggle-display-levels"),
      });

  const levelsChip = ChipElement({
    children: [titleNode, renameProjectButton],
    color: "grey",
  });

  const wireColor = state.showLevelsPanel ? "purple" : "darkgrey";
  const connectionWire = html`<div class="connection-wire ${wireColor}"></div>`;
  console;
  const levelSelect =
    state.playingTutorial && !state.currentTutorial.showLevelsPanel
      ? null
      : html`
          <div class="level-select-chip">${levelsChip} ${connectionWire}</div>
        `;

  return [chip, , levelSelect];
};
